var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3521 21.5404C14.4329 20.7248 11.7132 19.2626 11.1779 17.3608C10.2835 14.1837 12.8964 12.246 15.9981 14.0854C17.7181 11.0162 20.9988 11.4508 21.8931 14.6279C22.4285 16.5297 20.8413 19.0904 19.6076 20.71C19.0492 21.4433 18.77 21.8099 18.2126 21.952C17.6553 22.0942 17.2209 21.9096 16.3521 21.5404Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17314 7.65012C1.25133 11.0544 4.20243 15.6958 6.48618 18.6374C7.52004 19.969 8.03698 20.6349 9.0531 20.9043C9.88945 21.126 10.5686 20.9479 11.6572 20.5201C10.8264 19.811 10.0523 18.8979 9.734 17.7672C9.16279 15.738 9.64434 13.7245 11.2282 12.6137C12.4432 11.7616 13.9845 11.6687 15.4994 12.2009C16.5483 11.0089 17.9393 10.3656 19.4141 10.5226C20.3902 10.6266 21.2491 11.0653 21.9308 11.7432C22.6179 6.70789 18.0859 3.80603 12.8661 6.82283C9.66043 1.26426 3.7131 1.96307 2.17314 7.65012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.bba47bde6a3bdb32fd04f823bfdb5782.svg";
export { ForwardRef as ReactComponent };